// extracted by mini-css-extract-plugin
export var container = "haul-detail-module--container--9ad0b";
export var panel = "haul-detail-module--panel--63fe6";